export enum ImportantDatesPeriod {
  Today,
  ThisMonth,
  NextMonth
}
